module.exports = __webpack_public_path__ + "img/m7.13ffbdb2.png";